import React from 'react';
import { DisplayGridItemData } from './_DraggableGridItem';
import useFontLoader from 'Hooks/useFontLoader';
import { useSelector } from 'react-redux';
import { RootState } from 'Vendor/Store/store';

interface GridItemProps {
  item: DisplayGridItemData;
  isCover?: boolean;
  isSelected: boolean;
}

  const _GridItem: React.FC<GridItemProps> = ({ item, isCover = false, isSelected }) => {
  const platformFonts = useSelector((state: RootState) => state.assets.fonts);
  const content = item.content;

  const containerStyle: React.CSSProperties = {
    backgroundColor: item.styles.backgroundColor || 'transparent',
    color: item.styles.color,
    opacity: item.styles.opacity,
    outlineColor: item.styles.outlineColor,
    outlineStyle: item.styles.outlineStyle,
    outlineWidth: item.styles.outlineWidth,
    textAlign: item.styles.textAlign,
    zIndex: item.zIndex || "inherit",
    position: 'relative',
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: item.styles.fontFamily,
    fontSize: item.styles.fontSize,
    fontStyle: item.styles.fontStyle,
    fontWeight: item.styles.fontWeight,
    textDecoration: item.styles.textDecoration,
  };

  const renderContent = () => {
    switch (item.type) {
      case 'TEXT':
        return (
          <div
            className="w-100 h-100 p-2 d-flex align-items-center text-content"
            style={{
              textAlign: item.styles.textAlign || 'left',
              justifyContent: item.styles.textAlign === 'center' ? 'center' : item.styles.textAlign === 'right' ? 'flex-end' : 'flex-start',
            }}
          >
            <p
              className="mb-0"
              style={contentStyle}
            >
              {content.text || 'Text Block'}
            </p>
          </div>
        );
      case 'EXTERNAL_IMAGE':
      case 'PRODUCT':
      case 'FILE': {
        const isVideo = content.mimeType?.startsWith('video/') || content.src?.match(/\.(mp4|webm|ogg|mov|m4v|avi|flv)(.*)?$/i);
        if (isVideo) {
          return (
            <div className="w-100 h-100 position-relative video-container">
              <video
                src={content.src}
                controls
                loop
                muted
                playsInline
                className="grid-item-video"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: item.styles.objectFit || 'contain',
                  objectPosition: item.styles.objectPosition || 'center center',
                  transform: item.styles.transform ?? 'none',
                  transition: 'transform 0.3s ease',
                  transformOrigin: item.styles.transformOrigin || 'center center',
                }}
              />
            </div>
          );
        }
        return (
          <div className="w-100 h-100 position-relative image-container">
            <img
              src={content.src || 'https://placehold.co/400x400.png'}
              alt={content.alt || 'Placeholder image'}
              className="grid-item-image"
              style={{
                objectFit: item.styles.objectFit || 'contain',
                objectPosition: item.styles.objectPosition || 'center center',
                transform: item.styles.transform ?? 'none',
                transition: 'transform 0.3s ease',
                transformOrigin: item.styles.transformOrigin || 'center center',
              }}
              data-ai-hint="abstract background"
            />
          </div>
        );
      }
      default:
        return null;
    }
  };

  useFontLoader({
    family: item.styles.fontFamily,
    weight: item.styles.fontWeight,
    style: item.styles.fontStyle,
    platformFonts,
  });

  return (
    <div
      className="w-100 h-100 overflow-hidden grid-item-container"
      style={containerStyle}
    >
      {isCover && (
        <div className="cover-indicator" title="Cover image">
          <i className="fa-solid fa-star"></i>
        </div>
      )}
      {renderContent()}
    </div>
  );
};

export default _GridItem;
